module.exports = __webpack_public_path__ + "img/138.d9b54665.jpg";